(function () {
  function init() {
    const mq = window.matchMedia('(max-width: 768px)');
    if (!mq.matches) return;

    const observer = new MutationObserver(moveFooterUtilitiesText);

    function moveFooterUtilitiesText() {
      const utilitiesText = document.querySelector('footer .footer-utilities__text');
      const menuList = document.querySelector('footer .details-content ul.list-unstyled');

      if (!utilitiesText || !menuList) return;
      if (menuList.querySelector('.menu__item-copyright')) return;

      const li = document.createElement('li');
      li.className = 'menu__item paragraph menu__item-copyright';
      li.innerHTML = utilitiesText.innerHTML;
      menuList.appendChild(li);

      observer.disconnect();
    }

    observer.observe(document.body, { childList: true, subtree: true });
    moveFooterUtilitiesText();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
